export function convertMinutesToHours(minutes: number): number {
  return minutes / 60;
}

export function convertHoursToMinutes(hours: number): number {
  return hours * 60;
}

/**
 * Converts number of partial hours to minutes
 * @param hours
 * @returns {string}
 * @example
 * convertHoursToHoursAndMinutes(1.5) // '30'
 * convertHoursToHoursAndMinutes(1.25) // '15'
 **/
export function convertPartialHoursToMinutes(hours: number): number {
  return Math.round((hours % 1) * 60);
}
